import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { InfoTooltip } from './InfoTooltip';
import { Text } from '@/components/Typography';
import { CustomText } from '../Steps/Informations/Inputs/styles';

interface LabelProps {
	bold?: boolean;
	children: string;
	tooltip?: string;
	isRequired?: boolean;
}

export function Label({ children, tooltip, bold = true, isRequired = false }: Readonly<LabelProps>): JSX.Element {
	return (
		<Row justify="start" align="middle">
			<Col>
				<CustomText $bold={bold}>{I18n.get(children)}</CustomText>
			</Col>
			{isRequired && (
				<Col>
					<Text style={{ color: '#F80909', fontSize: '1rem' }}>*</Text>
				</Col>
			)}
			{tooltip && <InfoTooltip message={tooltip} />}
		</Row>
	);
}
